module.exports = __webpack_public_path__ + "img/13_newModelWorker_wgq.adb1580d.png";